import React from 'react';
import _ from 'lodash';
import getDisplayName from 'react-display-name';

/**
 * Prevent unwanted props to be passed to the component
 *
 * @param {React.Component} component
 * @param {array} propsToBeBlocked  list of props to be blocked
 * @returns {React.Component} component with the unwanted props blocked
 */
const blockProps = (component, propsToBeBlocked) => {
  const propsRemovedCopmonent = (props) => {
    const finalProps = _.omit(props, propsToBeBlocked);
    return React.createElement(component, finalProps);
  };
  propsRemovedCopmonent.displayName = `blockProps(${getDisplayName(
    component,
  )}, [${propsToBeBlocked.join(',')}])`;
  return propsRemovedCopmonent;
};

export default blockProps;



// WEBPACK FOOTER //
// ./src/utils/blockProps.js